export const SUPPORT_MIXPANEL_EVENTS = {
  viewed: {
    support: 'Viewed Support',
    category: 'Viewed Support Category',
  },

  clicked: {
    subcategory: 'Support Subcategory Clicked',
    article: 'Support Article Clicked',
  },
};
